import { useUiStore } from '@/store/ui/ui.store';
import { Backdrop, CircularProgress } from '@mui/material';

export default function BackDrop() {
  const isOpen = useUiStore(s => s.isGlobalLoading);

  return (
    <Backdrop sx={{ color: '#fff', zIndex: 99999 }} open={isOpen}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
